import { app } from '../../../../../app';
import { Controller } from './user-labels.controller';

app.component('companyUserLabels', {
    bindings: {
		companyId: '<',
		labels: '<',
		companyUsers:'<',
		labelGroup:'<',
		numberOfUsers: '<',
    },
    controller: Controller,
    templateUrl: require('./user-labels.html'),
});/**
 * 
 */


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/user-labels.component.js